import type { UserData } from '~/types/user';

const DEFAULT_SOCIAL_TITLE = 'bolt.new';
const DEFAULT_SOCIAL_DESCRIPTION = 'Prompt, run, edit & publish apps';
const DEFAULT_SOCIAL_IMAGE_URL = 'https://bolt.new/static/social_preview_index.jpg';

interface SocialData {
  description?: string;
  imageUrl?: string;
}

interface GeneralData {
  title: string;
  pageDescription?: string;
}

type GetMetaTagsParams = {
  generalData: GeneralData;
  user?: UserData | null;
  socialData?: SocialData;
};

export function getMetaTags({ user, socialData, generalData }: GetMetaTagsParams) {
  const { description = DEFAULT_SOCIAL_DESCRIPTION, imageUrl = DEFAULT_SOCIAL_IMAGE_URL } = socialData ?? {};
  const { title = DEFAULT_SOCIAL_TITLE, pageDescription } = generalData;

  const theme = user?.settings?.appearance?.theme;

  return [
    { title },
    ...(pageDescription ? [{ property: 'description', content: pageDescription }] : []),
    {
      property: 'og:type',
      content: 'object',
    },
    {
      property: 'og:site_name',
      content: 'bolt.new',
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:image',
      content: imageUrl,
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: description,
    },
    {
      name: 'twitter:image',
      content: imageUrl,
    },
    {
      name: 'twitter:site',
      content: '@StackBlitz',
    },
    {
      name: 'bolt-version',
      content: __COMMIT_HASH__,
    },
    ...(theme
      ? [
          {
            name: 'bolt-theme',
            content: theme,
          },
        ]
      : []),
  ];
}
